import { useEffect, useRef } from 'react';

export const useDurationTracking = (start: boolean) => {
  /** Duration Tracking */
  const startRef = useRef<number | null>(null);
  const now = () =>
    (typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now());

  useEffect(() => {
    if (start) {
      startRef.current = now();
    } else {
      startRef.current = null;
    }
  }, [start]);

  const getElapsedSeconds = () => {
    if (startRef.current == null) return null;
    return Math.round(now() - startRef.current) / 1000;
  };
  return { getElapsedSeconds };
};
